module.exports = __webpack_public_path__ + "img/Bice.78d31a0f.png";